import { render, staticRenderFns } from "./lawsuit-case-replies-tab.vue?vue&type=template&id=584171d0&scoped=true&"
import script from "./lawsuit-case-replies-tab.vue?vue&type=script&lang=js&"
export * from "./lawsuit-case-replies-tab.vue?vue&type=script&lang=js&"
import style0 from "./lawsuit-case-replies-tab.vue?vue&type=style&index=0&id=584171d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584171d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VProgressLinear,VRow})
